<template>
  <div class="callOrderManagement">
    <div class="callOrderManagement-m">
      <el-form
        :inline="true"
        :model="formsubmit"
        @keyup.enter.native.prevent="enterSearchMember(formsubmit)"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item label="搜索内容:">
          <el-input
            v-model.trim="formsubmit.content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="处理状态" >
          <el-select
            v-model="formsubmit.dealStatus"
            clearable
            placeholder="请选择处理状态"
            filterable
          >
            <el-option
              v-for="(item, index) in dealStatusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工单类型:">
          <el-select
            v-model="formsubmit.orderType"
            clearable
            placeholder="请选择工单类型"
            filterable
          >
            <el-option
              v-for="(item, index) in orderTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间:">
          <el-date-picker
            :editable="false"
            v-model="formsubmit.orderTime"
            unlink-panels
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            icon="el-icon-plus"
            plain
            @click.native.prevent="handleAdd"
            >新增</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-search"
            plain
            @click.native.prevent="onSubmit"
            >导出</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click.native.prevent="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="danger" icon="el-icon-delete" plain @click="onClear" 
            >清空查询选择</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          v-loading="loading"
          :data="orderList"
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          @selection-change="selsChange"
          highlight-current-row
        >
          <el-table-column
            label="序号"
            min-width="50"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="下单时间"
            min-width="120"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderTime }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="工单编号"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="客户姓名"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{
                scope.row.customerName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="联系电话"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="工单类型"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderType }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="处理状态"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.dealStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="接单人员"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderPeople }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="录音"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                ><img
                  src="@/assets/callcenter/sounds.png"
                  alt=""
                  class="handedness"
                  style="
                    margin-right: 2px;
                    width: 12px;
                    height: 12px;
                    vertical-align: middle;
                  "
              /></span>
              <span>{{ scope.row.sounds }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                plain
                icon="el-icon-circle-check-outline"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增dialog -->
    <el-dialog
      :title="operation ? '新增工单' : '修改工单'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataFormRules"
        label-width="160px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="工单编号" prop="orderNo">
              <!-- <el-input
                v-model.trim="dataForm.orderNo"
                placeholder="请输入"
                maxlength="14"
                style="width:220px;"
              ></el-input> -->
              <span style="height: 40px; line-height: 40px">{{
                dataForm.orderNo
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单类型" prop="orderType">
              <el-select
                v-model="dataForm.orderType"
                clearable
                placeholder="请选择工单类型"
                filterable
              >
                <el-option
                  v-for="(item, index) in orderTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户姓名" prop="customerName">
              <el-input
                v-model.trim="dataForm.customerName"
                placeholder="请输客户姓名"
                maxlength="14"
                style="width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接单人员" prop="orderPeople">
              <el-select
                v-model="dataForm.orderPeople"
                clearable
                placeholder="请选择接单人员"
                filterable
              >
                <el-option
                  v-for="(item, index) in orderPeopleList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input
                v-model.trim="dataForm.phone"
                placeholder="请输入联系电话"
                maxlength="14"
                style="width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接单时间" prop="orderTime">
              <el-date-picker
                style="width: 220px"
                class="datepicker"
                v-model="dataForm.orderTime"
                type="datetime"
                placeholder="请选择下单时间"
                :picker-options="pickerServiceTime"
                @change="changeServiceTime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="处理状态" prop="dealStatus">
              <el-select
                v-model="dataForm.dealStatus"
                clearable
                placeholder="请选择处理状态"
                filterable
              >
                <el-option
                  v-for="(item, index) in dealStatusList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="submit(dataForm)"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      operation: true,
      submitLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      orderList: [
        {
          orderTime: "2023/08/23 16:22:30",
          orderNo: "HJ201911241633",
          customerName: "刘青山",
          phone: "15926105967",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "云新建",
          sounds: "播放录音",
        },
        {
          orderTime: "2023/08/23 15:35:40",
          orderNo: "HJ201911241632",
          customerName: "李建国",
          phone: "13972303561",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "章慧嘉",
          sounds: "播放录音",
        },
        {
          orderTime: "2023/08/23 11:02:10",
          orderNo: "HJ201911241631",
          customerName: "邱秀珍",
          phone: "15971688892",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "柏忠林",
          sounds: "播放录音",
        },
        {
          orderTime: "2023/08/22 14:54:25",
          orderNo: "HJ201911241630",
          customerName: "占中秋",
          phone: "18971265320",
          orderType: "求助呼叫",
          dealStatus: "已处理",
          orderPeople: "邹文杰",
          sounds: "播放录音",
        },
        {
          orderTime: "2023/08/22 12:22:30",
          orderNo: "HJ201911241629",
          customerName: "李爱兰",
          phone: "17764052563",
          orderType: "设备呼叫",
          dealStatus: "已处理",
          orderPeople: "戚淑慧",
          sounds: "播放录音",
        },
      ],
      orderListOne: [
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "李四",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
      ],
      orderListTwo: [
        {
          orderTime: "2019-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "王五",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
      ],
      orderListThree: [
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "赵六",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "赵六",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "赵六",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
        {
          orderTime: "2020-07-24 14:22:34",
          orderNo: "HJ201911241630",
          customerName: "赵六",
          phone: "18971456712",
          orderType: "服务管理",
          dealStatus: "已处理",
          orderPeople: "王五",
          sounds: "播放录音",
        },
      ],
      sels: [], //列表选中列的checkbox集合
      totalDataNumber: 5, //数据的总数,
      loading: "", //加载数据中
      //查询传入的参数
      formsubmit: {
        content: "",
        dealStatus: "",
        orderType: "",
        orderTime: "",
      },
      dealStatusList: [
        {
          value: "0",
          label: "未处理",
        },
        {
          value: "1",
          label: "处理中",
        },
        {
          value: "2",
          label: "已处理",
        },
        {
          value: "3",
          label: "已回访",
        },
      ],
      orderTypeList: [
        {
          value: "0",
          label: "服务管理",
        },
        {
          value: "1",
          label: "设备呼叫",
        },
        {
          value: "2",
          label: "投诉管理",
        },
        {
          value: "3",
          label: "救助呼叫",
        },
      ],
      orderPeopleList: [
        {
          value: "0",
          label: "刘青山",
        },
        {
          value: "1",
          label: "李建国",
        },
        {
          value: "2",
          label: "邱秀珍",
        },
        {
          value: "3",
          label: "占中秋",
        },
        {
          value: "4",
          label: "李爱兰",
        },
      ],

      // 处理报警记录dialog
      dialogFormVisible: false,
      dataForm: {
        orderTime: "",
        orderNo: "HJ201911241633",
        customerName: "",
        phone: "",
        orderType: "",
        dealStatus: "",
      },
      formLabelWidth: "120px",
      dataFormRules: {},
      //element-ui 日期选择器如何限制只能选择一个月，超过一个月不能选择，也就是在选定起始日期时，只能向后面选择30天，同时不能选择超过今天的日期
      pickerMinDate: "",
      dateRange: [],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      pickerServiceTime: {
        disabledDate(time) {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },
    //清空 重置选取的值
    onClear() {
      this.formsubmit = {
        content: "",
        dealStatus: "",
        orderType: "",
        orderTime: "",
      };
    },

    //点击查询
    onSubmit() {},

    //键盘事件 按下键盘回车 查询
    enterSearchMember(formsubmit) {},

    /* 
      接单时间的change
    */

    changeServiceTime(val) {
      console.log(val);
      this.dataForm.orderTime = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log(this.dataForm.orderTime);
    },

    /* 
      新增
    */
    handleAdd() {
      this.dialogFormVisible = true;
      this.operation = true;
      this.dataForm = {
        orderTime: "",
        orderNo: "HJ201911241633",
        customerName: "",
        phone: "",
        orderType: "",
        dealStatus: "",
      };
    },

    /* 
      新增提交数据
    */
    submit(dataForm) {
      this.dialogFormVisible = false;
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
        }
      });
    },

    /* 
      修改
    */
    handleEdit(index, row) {
      console.log(index, row);
      this.dialogFormVisible = true;
      this.operation = false;
      this.dataForm = Object.assign({}, row);
    },

     // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      // return this.rowStyle;
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    //关闭处理报警dialog的回调
    closeDealAlarm() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警取消按钮
    cancelDealAlarm() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警记录 弹出dialog框
    handleDeal(index, row) {
      console.log(index, row);
      this.form = Object.assign({}, row);
      console.log(this.form);
      this.dialogFormVisible = true;
    },

    //选择的勾选的列
    selsChange: function (sels) {
      this.sels = sels;
      console.log(sels);
    },

    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      if (this.pageNum == 1) {
        this.orderList = this.orderListOne;
      } else if (this.pageNum == 2) {
        this.orderList = this.orderListTwo;
      } else if (this.pageNum == 3) {
        this.orderList = this.orderListThree;
      }
    },
  },
  watch: {
    currentPage(oldV, newV) {
      console.log(oldV, newV);
    },
  },

  created() {},

  mounted() {
    //this.orderList = this.orderListOne;
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.fenye {
  padding: 30px 0;
  background: #fff;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//处理报警记录的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dealalarm .el-dialog {
    width: 30% !important;
  }
}
</style>


